<div class="searchable-select" (click)="$event.stopPropagation()">
  <div class="searchable-select__field">
    <input
      #inputRef
      [id]="inputId"
      type="text"
      [value]="searchTerm"
      [placeholder]="placeholder"
      [disabled]="isDisabled"
      autocomplete="off"
      (focus)="onFocus()"
      (input)="onInput($event)"
      (blur)="onBlur()"
      (keydown)="onKeyDown($event)"
    />
    @if (hasSelection && !isDisabled) {
      <button
        type="button"
        class="searchable-select__clear"
        aria-label="Limpiar seleccion"
        title="Limpiar seleccion"
        (mousedown)="onOptionMouseDown($event)"
        (click)="clearSelection($event)"
      >
        <i class="fa-solid fa-xmark" aria-hidden="true"></i>
      </button>
    }
    <button
      type="button"
      class="searchable-select__toggle"
      [disabled]="isDisabled"
      aria-label="Abrir opciones"
      (click)="onToggleClick()"
    >
      <i class="fa-solid fa-chevron-down" aria-hidden="true"></i>
    </button>
  </div>

  @if (isOpen && !isDisabled) {
    <ul class="searchable-select__menu" role="listbox">
      @if (filteredOptions.length === 0) {
        <li class="searchable-select__empty">{{ noResultsLabel }}</li>
      }

      @for (
        option of filteredOptions;
        let i = $index;
        track trackByOptionValue(i, option)
      ) {
        <li>
          <button
            #optionBtn
            type="button"
            class="option"
            [class.active]="i === activeIndex"
            [disabled]="option.disabled"
            (mousedown)="onOptionMouseDown($event)"
            (click)="selectOption(option)"
            [innerHTML]="highlight(option.label)"
          ></button>
        </li>
      }
    </ul>
  }
</div>
